import { render, staticRenderFns } from "./LmfrBrightCoveViewer.vue?vue&type=template&id=3eda7ab6"
import script from "./LmfrBrightCoveViewer.vue?vue&type=script&lang=js"
export * from "./LmfrBrightCoveViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports